import page from 'page';
import { Configs, Topics } from "../app-lib/constants";
var storage = localStorage;
export function getUserId() {
    return storage.getItem("UserId");
}
export function getUsername() {
    return storage.getItem("Username");
}
export function getAccessToken() {
    return storage.getItem("AccessToken");
}
export function isLogin() {
    // ko.postbox.subscribe(Topics.app_isDD,n=>{
    //     console.log(false);
    //     return false;
    // })
    // console.log('wwww');
    // console.log('islogin')
    // console.log(!!getUserId())
    return !!getUserId();
}
export function signOut() {
    storage.removeItem("UserId");
    storage.removeItem("Username");
    storage.removeItem("AccessToken");
    ko.postbox.publish("Username", "");
    navigateToLoginUrl();
}
export function login(userId, username, accessToken) {
    storage.setItem("UserId", userId);
    storage.setItem("Username", username);
    storage.setItem("AccessToken", accessToken);
    ko.postbox.publish("Username", username);
    ko.postbox.publish(Topics.app_account_login, new Date().getMilliseconds());
    navigateToDefaultUrl();
}
export function navigateToDefaultUrl() {
    if (window.hasOwnProperty("cordova"))
        page(Configs.defaultUrlCordova);
    else
        page(Configs.defaultUrl);
}
export function navigateToLoginUrl() {
    page.stop();
    location.hash = Configs.loginUrl;
    location.reload();
    //page(Configs.loginUrl); 
}
export function navigateToRegisterUrl() {
    page(Configs.registerUrl);
}
export function navigateToLoginWhenNeeded() {
    if (isLogin())
        navigateToDefaultUrl();
    else
        navigateToLoginUrl();
}
